import { Navigate } from 'react-router-dom';

export const redirectTo =
  (path: string, replace = false) =>
  () => <Navigate replace={replace} to={path} />;
